module.exports = __webpack_public_path__ + "static/img/brees-2015-img-in-copy.1fc866a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2015-img-in-copy.jpg
// module id = v6nB
// module chunks = 1